import { connect } from 'react-redux';

import { IState } from '../../store/index';
import { getParent } from '../../utils/offer_helpers';
import { IParentProps, Parent } from './index';

export const AB_RELIABLE_NAME = 'ab_reliable';
export const AB_RELIABLE_GROUP = 1;

type TStoreProps = Pick<
  IParentProps,
  'agent' | 'businessShoppingCenter' | 'isABReliableExperimentActive' | 'offer' | 'parent'
>;
type TOwnProps = Pick<IParentProps, 'containerClassName'>;

function mapStateToProps(state: IState): TStoreProps {
  const reliableExperiment = state.experiments.find(experiment => experiment.name === AB_RELIABLE_NAME);

  const isReliableABGroupMatch = reliableExperiment && reliableExperiment.abGroup === AB_RELIABLE_GROUP;

  const isABReliableExperimentActive = isReliableABGroupMatch || false;

  return {
    agent: state.offerData.agent,
    businessShoppingCenter: state.offerData.businessShoppingCenter,
    isABReliableExperimentActive,
    offer: state.offerData.offer,
    parent: getParent(state.offerData),
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ParentContainer = connect<TStoreProps, any, TOwnProps>(mapStateToProps)(Parent);
